export default __webpack_public_path__ + "static/media/ps5-controller.62862013.png";